"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const _4d_mapper_1 = require("4d-mapper");
class QMapForm {
    constructor() {
        this.model = {};
        this.commence = new core_1.EventEmitter();
        this.cancel = new core_1.EventEmitter();
    }
    onSave() {
        this.commence.emit(this.model);
    }
    onCancel() {
        this.cancel.emit(this.model);
    }
}
exports.QMapForm = QMapForm;
